module.exports = __webpack_public_path__ + "img/water.a987e7f8.svg";